module.exports = __webpack_public_path__ + "img/loader.654e1916.svg";